var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.btnType},on:{"click":_vm.myClick}},[_vm._v(_vm._s(_vm.btnTxt))])
}
var staticRenderFns = []

export { render, staticRenderFns }